import { useState, useEffect, useCallback } from 'react';
import { buscarVencimentosFerias } from 'features/dp/services/dpFeriasService';

/**
 * Hook para buscar e gerenciar os alertas de vencimento de férias.
 * @param {string} statusFiltro - 'todos' | 'vencida' | 'vencendo' | 'pendente'
 */
export function useFeriasVencimentos(statusFiltro = 'todos') {
  const [dados, setDados] = useState([]);
  const [meta, setMeta] = useState({ total: 0 });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const carregar = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const resultado = await buscarVencimentosFerias(statusFiltro);
      setDados(resultado.data ?? []);
      setMeta(resultado.meta ?? { total: 0 });
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [statusFiltro]);

  useEffect(() => {
    carregar();
  }, [carregar]);

  return { dados, meta, loading, error, recarregar: carregar };
}
